import React from 'react';
const AuthContext = React.createContext({});
export default AuthContext;


// WEBPACK FOOTER //
// ./src/universal/components/auth/auth-context.js